export default __webpack_public_path__ + "static/media/Курчумский.317bea68.svg";